function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m1 1 6 6M7 1 1 7",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#362b24",
      strokeWidth: ".8px"
    },
    transform: "translate(.65 .65)"
  }));
};
export default SvgClose;